import React, { PureComponent } from 'react';
import { Modal, Row, Col, Button, Spin } from 'antd';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { permissionService } from 'shared/services';
import text from './ClientList.page.translation';
import './ClientList.style.less';

const { checkPermission } = permissionService;

class ClientDetailsModal extends PureComponent {
  renderTitle = () => {
    const {
      intl: { formatMessage },
    } = this.props;
    return (
      <div>
        <div className="title-container">
          {formatMessage(text.modalDetails.title)}
        </div>
        <div className="modal-separator" />
      </div>
    );
  };

  renderBody = () => {
    const {
      intl: { formatMessage },
      clientDetails,
    } = this.props;

    const clientName = get(clientDetails, 'name', '');
    const apiKey = get(clientDetails, 'api_key', '');
    const secretKey = get(clientDetails, 'secret_key', '');

    return (
      <div className="body-container">
        <Row className="row-details">
          <Col span={12}>
            {formatMessage(text.modalDetails.labelClientName)}
          </Col>
          <Col className="col-value" span={12}>
            {clientName}
          </Col>
        </Row>
        <Row className="row-details">
          <Col span={12}>{formatMessage(text.modalDetails.labelApiKey)}</Col>
          <Col className="col-value" span={12}>
            {apiKey}
          </Col>
        </Row>
        <Row className="row-details">
          <Col span={12}>{formatMessage(text.modalDetails.labelSecretKey)}</Col>
          <Col className="col-value" span={12}>
            {secretKey}
          </Col>
        </Row>
      </div>
    );
  };

  renderFooter = () => {
    const {
      intl: { formatMessage },
      handleClose,
      handleRefresh,
      refreshClientLoading,
    } = this.props;

    const canUpdateClient = checkPermission('Client:update', true);

    return (
      <div className="footer-container">
        <Button type="default" className="cancel-btn" onClick={handleClose}>
          {formatMessage(text.modalDetails.buttonClose)}
        </Button>
        {canUpdateClient && (
          <Button
            type="primary"
            className="btn"
            onClick={handleRefresh}
            loading={refreshClientLoading}
          >
            {formatMessage(text.modalDetails.buttonRefresh)}
          </Button>
        )}
      </div>
    );
  };

  renderContent = () => {
    const { getClientDetailsLoading } = this.props;

    if (getClientDetailsLoading) {
      return (
        <div className="spin-container">
          <Spin />
        </div>
      );
    }

    return (
      <div className="content-container">
        {this.renderBody()}
        {this.renderFooter()}
      </div>
    );
  };

  render = () => (
    <Modal
      className="delivery-client-details-modal"
      bodyStyle={{ padding: '0px' }}
      centered
      title=""
      visible={this.props.visible}
      footer={null}
      closable={false}
      destroyOnClose
    >
      {this.renderTitle()}
      {this.renderContent()}
    </Modal>
  );
}

ClientDetailsModal.propTypes = {
  visible: PropTypes.bool,
  intl: PropTypes.object,
  handleClose: PropTypes.func,
  handleRefresh: PropTypes.func,
  getClientDetailsLoading: PropTypes.bool,
  refreshClientLoading: PropTypes.bool,
  clientDetails: PropTypes.object,
};

export default ClientDetailsModal;
